<h1 mat-dialog-title>{{ "guidance.planningCycleName.edit" | translate }}</h1>
<form (ngSubmit)="save()" [formGroup]="form">
  <div mat-dialog-content>
    <mat-form-field>
      <input
        tabindex="1"
        formControlName="name"
        matInput
        name="name"
        placeholder="{{ 'guidance.planningCycleName.title' | translate }}"
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button tabindex="2" type="submit">
      {{ "guidance.save" | translate }}
    </button>
    <button (click)="cancel()" mat-button tabindex="3" type="button">
      {{ "guidance.cancel" | translate }}
    </button>
  </div>
</form>
